import perksGOTracking from "@irati-tracking/perksgo/perksGO";
export default (function (_a) {
    var showFidel = _a.showFidel, isManagedExternally = _a.isManagedExternally, showCustomisation = _a.showCustomisation;
    return [
        {
            label: "account.profile.label",
            to: "/profile"
        },
        {
            label: "account.contact.label",
            to: "/settings/contact"
        },
        {
            label: "account.payment.label",
            to: "/settings/payment"
        },
        showFidel && {
            label: "account.linked.label",
            to: "/settings/linkedcards",
            onClick: perksGOTracking.clickMyLinkedCards
        },
        !isManagedExternally && {
            label: "account.password.label",
            to: "/settings/password"
        },
        {
            label: "account.security.label",
            to: "/settings/security"
        },
        showCustomisation && {
            label: "account.customisation.interests.label",
            to: "/settings/customisation/categories"
        }
    ];
});
